import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { resolvePublicPage } from '../api/leadGeneration'

/** Strip the /lg mount prefix so API path matches rs-pages (e.g. events/my-event). */
function leadGenApiPath(pathname) {
  return pathname.replace(/^\/+/, '').replace(/^lg\/?/, '')
}

export function usePublicPage() {
  const { pathname } = useLocation()
  const [state, setState] = useState({ status: 'loading', page: null, error: null })

  useEffect(() => {
    const controller = new AbortController()
    setState({ status: 'loading', page: null, error: null })

    resolvePublicPage(
      { host: '', path: leadGenApiPath(pathname) },
      { signal: controller.signal },
    )
      .then((page) => setState({ status: 'success', page, error: null }))
      .catch((error) => {
        if (error.name === 'AbortError') return
        setState({ status: 'error', page: null, error })
      })

    return () => controller.abort()
  }, [pathname])

  useEffect(() => {
    if (state.page?.pageTitle) document.title = state.page.pageTitle
  }, [state.page])

  return state
}
